import axiosInstance from '../../api/axios';

const withLabel = (labelId, params = {}) => ({ label_id: labelId, ...params });

const BudgetTrackService = {
  getProviders: () => axiosInstance.get('/budget-track/providers'),

  getConnection: (labelId) =>
    axiosInstance.get('/budget-track/connection', { params: withLabel(labelId) }),

  getAuthUrl: (labelId, provider = 'google') =>
    axiosInstance.get('/budget-track/auth-url', { params: withLabel(labelId, { provider }) }),

  disconnect: (labelId) =>
    axiosInstance.delete('/budget-track/connection', { params: withLabel(labelId) }),

  sync: (labelId, forceFull = false) =>
    axiosInstance.post('/budget-track/sync', withLabel(labelId, forceFull ? { force_full: true } : {})),

  linkExpenses: (labelId, createMissing = false) =>
    axiosInstance.post('/budget-track/link-expenses', withLabel(labelId, { create_missing: createMissing })),

  getOverview: (labelId, year) =>
    axiosInstance.get('/budget-track/overview', { params: withLabel(labelId, { year }) }),

  getVendors: (labelId, month) =>
    axiosInstance.get('/budget-track/vendors', { params: withLabel(labelId, { month }) }),

  getEmails: (labelId, params = {}) =>
    axiosInstance.get('/budget-track/emails', { params: withLabel(labelId, params) }),

  exportEmails: (labelId, params = {}) =>
    axiosInstance.get('/budget-track/emails/export', {
      params: withLabel(labelId, params),
      responseType: 'blob',
    }),

  updateEmail: (id, payload) =>
    axiosInstance.patch(`/budget-track/emails/${id}`, payload),

  createExpense: (id) =>
    axiosInstance.post(`/budget-track/emails/${id}/create-expense`),

  getScanRules: (labelId) =>
    axiosInstance.get('/budget-track/scan-rules', { params: withLabel(labelId) }),

  updateScanRules: (labelId, rules) =>
    axiosInstance.put('/budget-track/scan-rules', withLabel(labelId, rules)),

  getSyncHistory: (labelId) =>
    axiosInstance.get('/budget-track/sync-history', { params: withLabel(labelId) }),

  getNotifications: (labelId) =>
    axiosInstance.get('/budget-track/notifications', { params: withLabel(labelId) }),

  markNotificationRead: (id) =>
    axiosInstance.patch(`/budget-track/notifications/${id}/read`),
};

export default BudgetTrackService;
